module.exports = __webpack_public_path__ + "static/media/image-5.4f4f2ef1.jpg";